import React, { useEffect, useState } from "react";
import { motion } from "motion/react";
import { PlayIcon } from "@heroicons/react/solid";
import { useDispatch, useSelector } from "react-redux";
import {
  initializeStream,
  setErrorState,
  setLoadingState,
} from "slice/checkMediaMTXSlice";
import { createMediaMTXWebRTCReader } from "Config/migrasiReader";
import {
  realtimeCamera,
  realtimeSelected,
  realtimeSelectedCamera,
} from "slice/realtimeSlice";
import { setUnsubscribed } from "slice/statusNatsSlice";
import { subs, unsubscribeMessage } from "Config/natsClient";

const ComponentNonN = ({ dataIpCamList = [], handleClickCamera }) => {
  const dispatch = useDispatch();
  const valueCamera = useSelector((state) => state.realtime.selected);
  const loadingStates = useSelector(
    (state) => state.checkMediaMTX.loadingStates
  );
  const errorStates = useSelector((state) => state.checkMediaMTX.errorStates);
  const [query, setQuery] = useState(window.location.search);
  // console.log(errorStates, "errorStates");
  // console.log(loadingStates, "loadingStates");

  useEffect(() => {
    dataIpCamList?.map((camera) => {
      dispatch(setLoadingState({ camera: camera.ip_address, isLoading: true }));
      createMediaMTXWebRTCReader({
        url: new URL("whep", `${camera.ip_address}/${query}`),
        onError: (err) => {
          console.error(`Streaming error on ${camera.ip_address}:`, err);
          dispatch(setErrorState({ camera: camera.ip_address, isError: true }));
          dispatch(
            setLoadingState({ camera: camera.ip_address, isLoading: false })
          );
        },
        onTrack: () => {
          dispatch(
            setErrorState({ camera: camera.ip_address, isError: false })
          );
          dispatch(
            setLoadingState({ camera: camera.ip_address, isLoading: false })
          );
        },
      });
    });
  }, [query, dataIpCamList, dispatch]);

  useEffect(() => {
    const handleURLChange = () => setQuery(window.location.search);
    window.addEventListener("popstate", handleURLChange);
    return () => window.removeEventListener("popstate", handleURLChange);
  }, []);

  const checkVideos = (camera) => {
    dispatch(initializeStream(camera));
    dispatch(setUnsubscribed());
    dispatch(realtimeSelectedCamera(null));
    dispatch(realtimeSelected(null));
    // setLoadingStates((prev) => ({ ...prev, [camera]: true }));
  };

  return (
    <div>
      {dataIpCamList?.length !== 0 ? (
        <ul className="space-y-3 ">
          {dataIpCamList.map((item, index) => {
            const isPlayingFile = valueCamera?.id === item?.id;
            return (
              <li
                key={item?.id}
                className="flex items-center justify-between cursor-pointer p-1"
                onClick={() => {
                  if (!errorStates[item?.ip_address]) {
                    handleClickCamera(item);
                  } else {
                    checkVideos(item?.ip_address);
                    unsubscribeMessage(subs);
                  }
                }}
              >
                <span className="text-sm text-mo-text">
                  {index + 1}.{" "}
                  {item?.device_name?.length > 20
                    ? item.device_name.slice(0, 20) + "..."
                    : item?.device_name || "Unknown Device"}
                </span>

                <div className="flex">
                  {isPlayingFile && (
                    <span className="italic text-xs text-yellow-400 me-1 flex items-center">
                      Playing
                    </span>
                  )}
                  <motion.div
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                  >
                    <PlayIcon
                      className={`h-5 text-mo-button ${isPlayingFile && "text-yellow-400"}`}
                    />
                  </motion.div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="text-sm w-full text-center">Kamera Kosong</div>
      )}
    </div>
  );
};

export default ComponentNonN;
